import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { ApplicationService } from 'src/modules/features/setting/services';
import { AppFilter } from '@app/shared/models';
import { CompanyService } from '../../services';
interface IAvaliableChangeModalContext {
  data: any;
  title?: string;
  isAvailable?: boolean;
}
@Component({
  selector: 'app-downgrade-entity-modal',
  templateUrl: './downgrade-entitiy-modal.component.html',
  styleUrls: ['./downgrade-entitiy-modal.component.scss'],
})
export class DowngradeEntityModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  screen: string;
  userForm: FormGroup;
  eRadio: any = 'mda';
  applications: Array<any> = [];
  filter: AppFilter = new AppFilter();

  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IAvaliableChangeModalContext, void, void>,
    private applicationSvc: ApplicationService,
    private companySvc: CompanyService
  ) {
    console.log(this.modal.context.data);
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });
    this.getApplications(1);
  }
  isFieldValid(field: string) {
    return (
      (!this.userForm.get(field).valid && this.userForm.get(field).touched) ||
      (this.userForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  getApplications(page) {
    this.filter.page = page;
    this.pending = true;
    this.applicationSvc.getApplications({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.applications = res['rows'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  save() {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.companySvc
      .downgradeEntity({
        body: {},
        organizationId: this.modal.context.data.organizationId,
        restrictedApplicationId: this.eRadio,
      })
      .subscribe(
        (res) => {
          this.success = 'Registered Company restricted successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    this.modal.approve(this.eRadio);
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class DowngradeEntityModal extends ComponentModalConfig<
  IAvaliableChangeModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isAvailable: boolean,
    size: ModalSize = ModalSize.Small
  ) {
    super(DowngradeEntityModalComponent, { title, data, isAvailable });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
